/*
 * Copyright (c) 2018 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can/view/view';
import Component from 'can/component/component';
import template from './photo-cover.stache';
import helpers from '../base/helpers';

Component.extend({
    tag: 'photo-cover',
    template: template,
    viewModel: {
        defined: {
            title: {
                type: 'string',
                value: 'Default',
            },
            image: {
                type: 'string',
                value: '',
            },
            isPinned: {
                type: 'boolean',
                value: false,
            },
            cardIndex: {
                type: 'number',
                value: 0,
            },
        },
    },
    helpers,
    events: {
        inserted($el) {
            this.viewModel.attr('element', $el);
        },
    },
});
